import { collection, query, where, orderBy, limit, getDocs } from "firebase/firestore";
import { firestore } from "../firebase";

export interface ArtistData {
    id: string;
    name: string;
    imageUrl: string;
    username: string;
}

export const NewArtistsService = {
    fetchNewArtists: async (limitCount: number = 18): Promise<ArtistData[]> => {
        try {
            const usersRef = collection(firestore, "users");

            const q = query(
                usersRef,
                where("userType", "==", "Artist"),
                orderBy("registerDate", "desc"),
                limit(limitCount)
            );

            const snapshot = await getDocs(q);

            const artists: ArtistData[] = snapshot.docs.map((doc) => {
                const data = doc.data();

                const artistName = data.artistName || data.name || "Unknown";
                const avatarUrl = data.avatarUrl || data.profileImage;
                const userNameHandle = data.userName || "";

                return {
                    id: doc.id,
                    name: artistName,
                    imageUrl: avatarUrl || "https://via.placeholder.com/150",
                    username: userNameHandle,
                };
            });

            return artists;
        } catch (error) {
            console.error("Error fetching new artists:", error);
            return [];
        }
    },
};